(function () {
  "use strict";

  function replaceExact(selector, from, to) {
    document.querySelectorAll(selector).forEach(function (element) {
      if (element.textContent.trim() === from) element.textContent = to;
    });
  }

  function normalizeBrandName() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var parent = node.parentElement;
      if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(parent.tagName)) return;
      if (/Moonman Paints/i.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(/Moonman Paints/gi, "Moon Man Paints");
      }
    });
  }

  function improveHomepageCopy() {
    replaceExact(
      ".real-product-worlds__heading p",
      "Three real, active store products rotate through each world. Every scene preserves the exact artwork or product photography.",
      "Explore original art, atmospheric photography, and wearable pieces created to bring resilience, imagination, and the natural world into everyday life."
    );

    var cardCopy = {
      "Celestial Genesis": ["Original visionary artwork", "A cosmic meditation on nature, imagination, and the infinite—available in museum-quality formats."],
      "In Vein": ["Symbolic fine art", "A haunting exploration of mortality, consciousness, and humanity’s place in the universe."],
      "Tranquility": ["Moons of Wisdom", "A quiet meditation on balance, stillness, and wisdom beneath the night sky."],
      "Between Stone and Light": ["Yosemite photography", "Yosemite light and stone captured in a quiet, gallery-ready composition."],
      "Looking Back Through the Rainbow": ["Yosemite Mist Trail", "Rainbow, granite, and mist transformed into a luminous landscape print."],
      "Vernal Fall Rainbow": ["Yosemite photography", "Vernal Fall and rainbow light preserved as an atmospheric fine-art photograph."],
      "Beyond the Veil Tee": ["Signature Series Tee", "Visionary artwork carried beyond the canvas on a soft, artist-designed tee."],
      "Original Logo Hoodie": ["Unisex Hoodie", "The original Moon Man identity on a comfortable hoodie built for everyday adventure."],
      "Rooted in Nature Tee": ["Signature Series Tee", "Botanical imagination and resilience brought to life as wearable art."]
    };

    document.querySelectorAll("[data-real-product-slide]").forEach(function (slide) {
      var replacement = cardCopy[slide.getAttribute("data-product-label")];
      if (!replacement) return;
      var kicker = slide.querySelector(".real-product-card__kicker");
      var description = slide.querySelector(".real-product-card__content > span:last-child");
      if (kicker) kicker.textContent = replacement[0];
      if (description) description.textContent = replacement[1];
    });

    document.querySelectorAll("img[alt]").forEach(function (image) {
      image.alt = image.alt
        .replace(/active Shopify product photo/gi, "official Moon Man Paints product photograph")
        .replace(/active Shopify artwork/gi, "original Moon Man Paints artwork");
    });

    var linkChanges = {
      "/products/untitled-jul25_09-50-38": "/products/celestial-genesis-fine-art-print",
      "/products/unisex-garment-dyed-heavyweight-t-shirt": "/products/paint-beyond-limits-heavyweight-tee-light-colors",
      "/products/unisex-garment-dyed-heavyweight-t-shirt-1": "/products/paint-beyond-limits-heavyweight-tee-dark-colors",
      "/products/unisex-garment-dyed-heavyweight-t-shirt-2": "/products/stay-rooted-find-beauty-heavyweight-botanical-tee",
      "/products/unisex-garment-dyed-heavyweight-t-shirt-3": "/products/guided-by-nature-heavyweight-botanical-tee",
      "/products/unisex-garment-dyed-heavyweight-t-shirt-4": "/products/fueled-by-passion-heavyweight-botanical-tee",
      "/products/unisex-garment-dyed-heavyweight-t-shirt-5": "/products/bloom-through-every-season-heavyweight-botanical-tee"
    };
    document.querySelectorAll("a[href]").forEach(function (link) {
      var href = link.getAttribute("href");
      if (linkChanges[href]) link.setAttribute("href", linkChanges[href]);
    });
  }

  function guideForProduct() {
    var tables = document.querySelectorAll(".product-block--description table");
    if (!tables.length) {
      return "<p>A size chart is not listed for this item. Please ask the studio for product-specific measurements before ordering.</p>";
    }
    return Array.prototype.map.call(tables, function (table) {
      var unit = table.parentElement.getAttribute("data-unit-system");
      var heading = unit === "imperial" ? "Measurements in inches" : unit === "metric" ? "Measurements in centimeters" : "Product measurements";
      return "<h3>" + heading + "</h3><div class=\"mmp-size-guide-dialog__table-wrap\">" + table.outerHTML + "</div>";
    }).join("");
  }

  function addSizeGuide(sizeOption, productTitle) {
    var label = sizeOption.querySelector("label");
    if (!label || label.querySelector(".mmp-size-guide__button")) return;

    var dialogId = "MoonManSizeGuide";
    var button = document.createElement("button");
    button.type = "button";
    button.className = "mmp-size-guide__button";
    button.textContent = "Size guide & fit";
    button.setAttribute("aria-haspopup", "dialog");
    button.setAttribute("aria-controls", dialogId);
    label.appendChild(button);

    var dialog = document.createElement("dialog");
    dialog.id = dialogId;
    dialog.className = "mmp-size-guide-dialog";
    dialog.innerHTML =
      "<div class=\"mmp-size-guide-dialog__inner\">" +
      "<button class=\"mmp-size-guide-dialog__close\" type=\"button\" aria-label=\"Close size guide\">×</button>" +
      "<h2>Size guide & fit</h2>" +
      "<p>Use the product-specific measurements below. Units and measurement types are shown in each chart.</p>" +
      guideForProduct(window.location.pathname, productTitle) +
      "<p class=\"mmp-size-guide-dialog__tip\"><strong>Best fit check:</strong> Lay a shirt you already like flat, measure it the same way, and compare the numbers. Because each piece is made to order, please check your size before purchasing.</p>" +
      "<p>Still unsure? <a href=\"/pages/contact\">Ask the studio before ordering</a> and include the product name and size you are considering.</p>" +
      "</div>";
    document.body.appendChild(dialog);

    function closeDialog() { if (dialog.open) dialog.close(); }
    button.addEventListener("click", function () {
      if (typeof dialog.showModal === "function") dialog.showModal();
      else dialog.setAttribute("open", "");
    });
    dialog.querySelector(".mmp-size-guide-dialog__close").addEventListener("click", closeDialog);
    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) closeDialog();
    });
  }

  function addShippingNote(productSection, isArtwork, isApparel) {
    var buyButtons = productSection.querySelector(".product-buy-buttons");
    if (!buyButtons || productSection.querySelector(".mmp-shipping-note")) return;

    var note = document.createElement("div");
    note.className = "mmp-shipping-note";
    note.setAttribute("aria-label", "Production and shipping estimate");

    if (isArtwork) {
      note.innerHTML = "<strong>Made to order • Typical U.S. delivery: about 5–8 business days</strong>Standard U.S. artwork shipping is calculated by order value and ranges from $19.95–$64.95. Your exact rate is shown at checkout before payment. Tracking is emailed when available. <a href=\"/policies/shipping-policy\">Shipping details</a>";
    } else if (isApparel) {
      note.innerHTML = "<strong>Made to order • Typical U.S. delivery: about 5–9 business days</strong>Delivery is estimated. Shipping is additional; your exact rate appears at checkout before payment. Tracking is emailed after fulfillment. <a href=\"/policies/shipping-policy\">Shipping details</a>";
    } else {
      note.innerHTML = "<strong>Made to order with tracked shipping when available</strong>Production time and shipping charges vary by item and destination. Your exact rate appears at checkout before payment. <a href=\"/policies/shipping-policy\">Shipping details</a>";
    }

    buyButtons.parentNode.insertBefore(note, buyButtons);
  }

  function improveProductPage() {
    var section = document.querySelector(".product-section");
    if (!section) return;

    var titleElement = section.querySelector(".product-info__title");
    var productTitle = titleElement ? titleElement.textContent.trim() : "this item";
    var options = Array.prototype.slice.call(section.querySelectorAll(".product-option"));
    var materialOption = options.find(function (option) {
      var label = option.querySelector("label");
      return label && /\bmaterial\b/i.test(label.textContent);
    });
    var sizeOption = options.find(function (option) {
      var label = option.querySelector("label");
      return label && /\bsize\b/i.test(label.textContent);
    });
    var colorOption = options.find(function (option) {
      var label = option.querySelector("label");
      return label && /\bcolor\b/i.test(label.textContent);
    });

    var isArtwork = Boolean(materialOption);
    var isApparel = Boolean(sizeOption && (colorOption || !materialOption));
    addShippingNote(section, isArtwork, isApparel);
    if (isApparel && sizeOption) addSizeGuide(sizeOption, productTitle);
  }

  function fixArtistStoryTitle() {
    if (window.location.pathname === "/pages/artist-story") {
      document.title = "Artist Story – Moon Man Paints";
    }
  }

  function init() {
    normalizeBrandName();
    improveHomepageCopy();
    improveProductPage();
    fixArtistStoryTitle();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();